import React, { FormEvent, useState } from 'react';
import { Button } from '@mui/material';
import { toast } from 'react-toastify';
import Appbar from 'components/appbar/Appbar';
import InsideSaving from 'components/loading/InsideSaving';
import {
  ContentPad,
  PageShell,
  RecordFooter,
  RecordHeader,
  StyledForm,
  WorkArea,
} from 'components/record-shell/RecordShell';
import { api } from 'services/api';
import history from 'services/history';
import { Product } from 'types/product';
import ProductForm from '../form/ProductForm';

const NewProduct: React.FC = () => {
  const [validation, setValidation] = useState('');
  const [saving, setSaving] = useState(false);
  const [product, setProduct] = useState<Product>({
    id: 0,
    name: '',
    manufacturer: '',
    unit: 'un',
  });

  function goBack() {
    history.push('/products');
  }

  function handleChange<K extends keyof Product>(index: K, value: Product[K]) {
    setProduct(prev => ({ ...prev, [index]: value }));
  }

  function handleSubmit() {
    setSaving(true);

    api
      .post('/products', { ...product, unit: product.unit || 'un' })
      .then(response => {
        toast.success('Produto cadastrado');
        // abre o produto recém-cadastrado
        history.push(response.data?.id ? `/products/${response.data.id}` : '/products');
      })
      .catch(err => {
        toast.error(err.response?.data?.error || 'Não foi possível cadastrar o produto');
      })
      .finally(() => setSaving(false));
  }

  function handleValidation(e?: FormEvent<HTMLFormElement>) {
    e?.preventDefault();
    setValidation('');
    if (!product.name) {
      setValidation('name');
      return;
    }
    if (!product.manufacturer) {
      setValidation('manufacturer');
      return;
    }
    handleSubmit();
  }

  return (
    <>
      <Appbar title="Produtos" backAction={goBack} />

      {saving && <InsideSaving />}

      <PageShell>
        <RecordHeader title="Novo produto" backAction={goBack} />

        <WorkArea>
          <ContentPad>
            <StyledForm onSubmit={handleValidation}>
              <ProductForm handleChange={handleChange} product={product} validation={validation} />
              <button type="submit" style={{ display: 'none' }}></button>
            </StyledForm>
          </ContentPad>
        </WorkArea>

        <RecordFooter>
          <Button variant="contained" size="small" disabled={saving} onClick={() => handleValidation()}>
            Salvar produto
          </Button>
        </RecordFooter>
      </PageShell>
    </>
  );
};

export default NewProduct;
